import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-6"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = { class: "py-3 flex items-end justify-between" }
const _hoisted_4 = { class: "flex gap-x-16" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "font-semibold text-black-lp-300" }
const _hoisted_7 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "font-semibold text-black-lp-300" }
const _hoisted_10 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "font-semibold text-black-lp-300" }
const _hoisted_13 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300" }
const _hoisted_16 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_17 = { class: "flex gap-x-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = { class: "w-full relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_UpdateDeliveryFormDeleteStt = _resolveComponent("UpdateDeliveryFormDeleteStt")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.listStt.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("updateDelivery.form.totalStt")), 1),
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.totalStt), 1)
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("updateDelivery.form.totalKoli")), 1),
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.totalSttPieces), 1)
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("updateDelivery.form.totalGrossWeight")), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.totalSttGrossWeight) + " Kg ", 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("updateDelivery.form.totalVolumeWeight")), 1),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.totalSttVolumeWeight) + " Kg ", 1)
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_LpButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDeleteStt = true)),
                outline: "",
                iconLeft: "delete",
                title: _ctx.$t('updateDelivery.form.delete'),
                textColor: "red-lp-300"
              }, null, 8, ["title"]),
              _createVNode(_component_LpButton, {
                onClick: _ctx.togglePanel,
                icon: 
              _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
            ,
                title: _ctx.$t('updateDelivery.form.process'),
                textColor: "white",
                disabled: !_ctx.isFormValid
              }, null, 8, ["onClick", "icon", "title", "disabled"]),
              _createVNode(_component_OverlayPanel, {
                ref: "op",
                appendTo: "body",
                style: {"width":"auto"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpButton, {
                    class: "w-60",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onProcessDel(false))),
                    flat: "",
                    dense: "",
                    iconLeft: "delivery",
                    title: _ctx.$t('updateDelivery.form.updateDel')
                  }, null, 8, ["title"]),
                  _hoisted_18,
                  _createVNode(_component_LpButton, {
                    class: "w-full",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onProcessDel(true))),
                    flat: "",
                    dense: "",
                    iconLeft: "printer",
                    title: _ctx.$t('updateDelivery.form.updateAndPrintPdf')
                  }, null, 8, ["title"])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_TableV2, {
              data: _ctx.listStt,
              columns: _ctx.columns,
              borderTop: false,
              pagination: _ctx.pagination,
              "is-hard-pagination": true,
              "is-quick-search": true,
              "is-sorting": true,
              "pagination-style": "v2",
              isRightFreeze: "",
              totalColumnFreeze: 0,
              autoHeight: "",
              isPinnedScrollBottom: false
            }, null, 8, ["data", "columns", "pagination"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.openDeleteStt,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDeleteStt = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UpdateDeliveryFormDeleteStt, { onClose: _ctx.onCloseDeleteStt }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}